/* eslint-disable-next-line @typescript-eslint/no-explicit-any --
 * See aka.ms/mini-lint-errors
 *	> Unexpected any. Specify a different type. */
export function isNullOrUndefined(value: any): boolean {
    return [null, undefined].includes(value);
}
